<template>
  <div class="modal-custom">
    <div class="modal-content">
      <div @click="$emit('close')" class="close bold">x</div>
      <h3 class="pt-3 text-center rojo bold">Restablecer contraseña</h3>
      <div v-if="!showSuccess" class="blanco">
        <p class="text-center">
          Ingresa tu correo y si está registrado en el sitio te enviaremos un
          correo de recuperación:
        </p>

        <div class="row">
          <div class="col-md-6 offset-md-3">
            <form @submit="resetPassword($event)">
              <input
                v-model.trim="no_cliente"
                type="text"
                placeholder="No. de Cliente"
                class="text-center"
                required
              />

              <input
                v-model.trim="email"
                type="email"
                placeholder="E-mail"
                class="text-center"
                required
              />

              <button
                type="submit"
                class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
              >
                Restablecer
              </button>
            </form>
          </div>
        </div>
        <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
      </div>
      <p v-else class="text-center fG">
        Hemos enviado un correo al email asociado a la cuenta, por favor revisa tu bandeja de entrada y/o spam y da clic en la liga de recuperación de contraseña.
      </p>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import swal from "sweetalert2";

export default {
  data() {
    return {
      email: "",
      no_cliente: "",
      showSuccess: false,
      errorMsg: "",
    };
  },
  methods: {
    async resetPassword(e) {
      e.preventDefault();

      this.errorMsg = "";

      const https = require("https");
      var qData = {
        no_cliente: this.no_cliente,
        email: this.email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "restablecer.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              //swal.fire("Bien", "Hemos enviado un correo al email asociado a la cuenta, por favor revisa tu bandeja de entrada y/o spam y da clic en la liga de recuperación de contraseña.", "warning");
              this.showSuccess = true;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
  },
};
</script>
